import 'reflect-metadata';

import IDynamicContent from '@orcha/types/dynamic-content';
import { injectable } from 'inversify';
import ApiClient from './api-client';
import { IDynamicContentService } from './interfaces';

@injectable()
class DynamicContentService implements IDynamicContentService {
  private apiClient: ApiClient;

  public constructor() {
    this.apiClient = new ApiClient(
      process.env.DYNAMIC_CONTENT_API_BASE_URL ?? ''
    );
  }

  public async getDynamicContentByReviewId(
    reviewId: number,
    accountType: string,
    language?: string
  ) {
    const response = await this.apiClient.get<IDynamicContentDataWrapper>(
      `dynamiccontent?reviewId=${reviewId}&accountType=${accountType}${
        language ? `&language=${language.toLocaleLowerCase()}` : ''
      }`
    );

    return response?.data?.dynamicContent;
  }
}

interface IDynamicContentDataWrapper {
  data?: { dynamicContent: IDynamicContent };
  success: boolean;
}

export default DynamicContentService;
